import { useEffect, useState } from "react";
import "./styles/indicadores.css";
import InternalError from "../generales/InternalError";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import General from "./General";
import WorkStation from "./WorkStation";
import Printers from "./Printers";
import Phones from "./Phones";
import AccessPoint from "./AccesPoint";
import Switches from "./Switches";
import Routers from "./Routers";
import Laptops from "./Laptops";
import Fingerprints from "./Fingerprints";
import ModalHistoric from "./ModalHistoric";
import Modal from "react-modal";
import ModalEvents from "./ModalEvents";
import PanelDevice from "./PanelDevice";
import PanelTableGroups from "./PanelTableGroups";
import { useFetch } from "../../hooks/useFetch";
import ModalAddGroup from "./ModalAddGroup";
import ModalDeleteTab from "./ModalDeleteTab";
const addHostModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    height: '85%',
    padding: '20px'
  },
};
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '20%',
    padding: '20px'
  },
};
const PaneGrupos = ({ handleShowPopup, pageSelected, globals, server, dataGlobals, languaje, mode, estados_list, userPermissions, token, estadoSelected, setEstadoSelected }) => {
  // const [listSelected, setListSelected] = useState(0);
  // const [techSelected, setTechSelected] = useState(0);
  const [internalError, setInternalError] = useState(false)
  const [hostSelected, setHostSelected] = useState({})
  const dataTechs = useFetch('zabbix/groups/municipios', '', token, 'GET', server)
  const municipios = dataTechs.loading ? [] : dataTechs.data.data.map(element => element.groupid)
  // const dataView=useFetch('cassia/monitoring_devices/status_report/custom-tabs','',token,'GET',server)
  const [dataView, setDataView] = useState({
    data: [],
    loading: true,
    error: null,
  })
  // const [listSelected, setListSelected] = useState(dataView.loading?0:((dataView.data.data.length==0)?[]:dataView.data.data[0].id));
  // const [techSelected, setTechSelected] = useState(dataView.loading?0:((dataView.data.data.length==0)?[]:dataView.data.data[0].name));
  const [listSelected, setListSelected] = useState(dataView.loading ? 0 : ((dataView.data.data.length == 0) ? [] : 0));
  const [techSelected, setTechSelected] = useState(dataView.loading ? 0 : ((dataView.data.data.length == 0) ? [] : 'Municipio'));
  useEffect(() => {
    // setListSelected(dataView.loading?0:((dataView.data.data.length==0)?[]:dataView.data.data[0].id))
    // setTechSelected(dataView.loading?0:((dataView.data.data.length==0)?[]:dataView.data.data[0].name))
    setListSelected(dataView.loading ? 0 : ((dataView.data.data.length == 0) ? [] : 0))
    setTechSelected(dataView.loading ? '' : ((dataView.data.data.length == 0) ? [] : 'Municipio'))
  }, [dataView.loading])
  const hadleChangeList = (e, tite) => {
    setListSelected(e);
    setTechSelected(tite)
  };
  const [addHostModalOpen, setAddHostModalOpen] = useState(false);
  function openAddHostModal() {

    //   console.log('open')
    setAddHostModalOpen(true);
  }

  function closeAddHostModal() {

    setAddHostModalOpen(false);
  }
  function showHistoric(element) {
    setHostSelected(element); // Esto debería funcionar si se pasa correctamente
    openAddHostModal();      // Esto también
  }


  const [dataAnalisis, setDataAnalisis] = useState({ data: {}, loading: true, error: {} })

  const token_item = localStorage.getItem('access_token')
  const [modalAddCorIsOpen, setAddCorIsOpen] = useState(false);
  const [allSelected, setAllSelected] = useState(false)
  const [editActive, setEditActive] = useState(false)
  const [tab, setTab] = useState(0)
  const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);
  function openDeleteUserModal(tab) {
    setTab(tab)
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    // setSearchTerm("")

    setDeleteUserModalOpen(false);
  }
  function openModalAddCor(editActive, tab) {
    setEditActive(editActive)
    setTab(tab)
    setAddCorIsOpen(true);
  }

  function closeModalAddCor() {
    setPoolObjectRows([])
    setPoolRows([])
    setAllSelected(false)
    setAddCorIsOpen(false);
  }
  useEffect(() => {
    search_tabs()
  }, [])
  const search_tabs = () => {
    setDataView({
      data: dataView.data,
      loading: true,
      error: dataView.error,
    });

    const fetchDataPost = async () => {
      try {
        // console.log(
        //   server.url +
        //     "/api/v1/cassia/monitoring_devices/status_report/custom-tabs"
        // );
        const response = await fetch(
          server.url +
          "/api/v1/cassia/monitoring_devices/status_report/custom-tabs/",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        // console.log(response);
        if (response.ok) {
          const data1 = await response.json();

          // console.log(data1);
          setDataView({
            data: data1,
            loading: false,
            error: dataView.error,
          });
          // setLoading(false)
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          // console.log(data1);
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const [poolRows, setPoolRows] = useState([])
  const [poolObjectRows, setPoolObjectRows] = useState([])
  const [response, setResponse] = useState(null);
  const [wsAnalisis, setWsAnalisis] = useState(null);
  useEffect(() => {
    // console.log('------------------------------------------------data')
    // search_analisis()

    // enviarDatos()
    const websocketAnalisis = new WebSocket(server.ws + "/api/v1/cassia/monitoring_devices/status_report/ws/status");

    websocketAnalisis.onopen = () => {
      setDataAnalisis({ data: [], loading: true, error: dataAnalisis.error })
    };

    websocketAnalisis.onmessage = (event) => {
      const response = JSON.parse(event.data);
      setResponse(response); // Actualizar el estado con la respuesta
      setDataAnalisis({ data: response, loading: false, error: {} })
    };

    websocketAnalisis.onerror = (error) => {
      console.error("Error en el WebSocket:", error);
    };

    websocketAnalisis.onclose = () => { };

    setWsAnalisis(websocketAnalisis);


    // Cerrar el WebSocket cuando el componente se desmonta
    return () => {

      websocketAnalisis.close();
    };
  }, [])
  return (
    <>
      <div className={"main-config" + mode}>
        {/* {(internalError)?
            <InternalError/>
            :renderAdminComponent()} */}

        <div className={'main-config' + mode}>
          {/* PESTAÑAS REDISEÑADAS */}
          <div style={{
            borderBottom: '1px solid #e2e8f0',
            background: mode === 'Dark' ? '#1e293b' : '#fff',
            padding: '0 24px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              minHeight: 56
            }}>

              {/* Botón + para crear nuevo grupo */}
              {!dataView.loading && (
                <button
                  onClick={() => { openModalAddCor(false) }}
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    background: '#1a56db',
                    color: '#fff',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 20,
                    fontWeight: 500,
                    transition: 'all 0.2s',
                    flexShrink: 0
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = '#0f2d5e';
                    e.currentTarget.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = '#1a56db';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  +
                </button>
              )}

              {/* Pestañas */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                overflow: 'auto',
                flex: 1,
                msOverflowStyle: 'none',
                scrollbarWidth: 'none'
              }}>
                {dataView.loading ? (
                  <span style={{
                    fontSize: 14,
                    color: 'var(--color-text-secondary)',
                    padding: '0 16px'
                  }}>
                    Cargando...
                  </span>
                ) : dataView.data.data.length === 0 ? (
                  <span style={{
                    fontSize: 14,
                    color: '#db2777',
                    padding: '0 16px'
                  }}>
                    No existe algún grupo creado
                  </span>
                ) : (
                  <>
                    {/* Pestaña Municipio (default, no editable) */}
                    <div
                      onClick={() => hadleChangeList(0, capitalizeFirstLetter(lang[languaje]['municipio']))}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        padding: '10px 16px',
                        fontSize: 13,
                        fontWeight: 500,
                        cursor: 'pointer',
                        borderRadius: '8px 8px 0 0',
                        transition: 'all 0.2s',
                        background: listSelected === 0 ? '#1a56db' : 'transparent',
                        color: listSelected === 0
                          ? '#fff'
                          : (mode === 'Dark' ? '#cbd5e1' : '#64748b'),
                        borderBottom: listSelected === 0
                          ? '2px solid #1a56db'
                          : '2px solid transparent',
                        whiteSpace: 'nowrap',
                        fontFamily: "'DM Sans', system-ui, sans-serif"
                      }}
                      onMouseEnter={e => {
                        if (listSelected !== 0) {
                          e.currentTarget.style.background = mode === 'Dark' ? '#334155' : '#f8fafc';
                          e.currentTarget.style.color = mode === 'Dark' ? '#f1f5f9' : '#0f2d5e';
                        }
                      }}
                      onMouseLeave={e => {
                        if (listSelected !== 0) {
                          e.currentTarget.style.background = 'transparent';
                          e.currentTarget.style.color = mode === 'Dark' ? '#cbd5e1' : '#64748b';
                        }
                      }}
                    >
                      {capitalizeFirstLetter(lang[languaje]['municipio'])}
                    </div>

                    {/* Pestañas creadas dinámicamente */}
                    {dataView.data.data.map((element, index) => (
                      <div
                        key={element.id}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          position: 'relative'
                        }}
                      >
                        <div
                          onClick={() => hadleChangeList(element.id, element.name)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '10px 40px 10px 16px',
                            fontSize: 13,
                            fontWeight: 500,
                            cursor: 'pointer',
                            borderRadius: '8px 8px 0 0',
                            transition: 'all 0.2s',
                            background: listSelected === element.id ? '#1a56db' : 'transparent',
                            color: listSelected === element.id
                              ? '#fff'
                              : (mode === 'Dark' ? '#cbd5e1' : '#64748b'),
                            borderBottom: listSelected === element.id
                              ? '2px solid #1a56db'
                              : '2px solid transparent',
                            whiteSpace: 'nowrap',
                            fontFamily: "'DM Sans', system-ui, sans-serif",
                            position: 'relative'
                          }}
                          onMouseEnter={e => {
                            if (listSelected !== element.id) {
                              e.currentTarget.style.background = mode === 'Dark' ? '#334155' : '#f8fafc';
                              e.currentTarget.style.color = mode === 'Dark' ? '#f1f5f9' : '#0f2d5e';
                            }
                          }}
                          onMouseLeave={e => {
                            if (listSelected !== element.id) {
                              e.currentTarget.style.background = 'transparent';
                              e.currentTarget.style.color = mode === 'Dark' ? '#cbd5e1' : '#64748b';
                            }
                          }}
                        >
                          {element.name}
                        </div>

                        {/* Botones eliminar y editar (vertical) */}
                        <div style={{
                          position: 'absolute',
                          right: 8,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 2,
                          zIndex: 10
                        }}>
                          {/* Eliminar (arriba) */}
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              openDeleteUserModal(element);
                            }}
                            style={{
                              width: 18,
                              height: 18,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer',
                              borderRadius: 3,
                              transition: 'all 0.2s',
                              fontSize: 16,
                              fontWeight: 600,
                              lineHeight: 1,
                              color: listSelected === element.id ? '#fff' : '#db2777',
                              opacity: 0.7
                            }}
                            onMouseEnter={e => {
                              e.currentTarget.style.opacity = 1;
                              e.currentTarget.style.background = 'rgba(219, 39, 119, 0.15)';
                            }}
                            onMouseLeave={e => {
                              e.currentTarget.style.opacity = 0.7;
                              e.currentTarget.style.background = 'transparent';
                            }}
                          >
                            ×
                          </div>

                          {/* Editar (abajo) */}
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              openModalAddCor(true, element);
                            }}
                            style={{
                              width: 18,
                              height: 18,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer',
                              borderRadius: 3,
                              transition: 'all 0.2s',
                              opacity: 0.7
                            }}
                            onMouseEnter={e => {
                              e.currentTarget.style.opacity = 1;
                              e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                            }}
                            onMouseLeave={e => {
                              e.currentTarget.style.opacity = 0.7;
                              e.currentTarget.style.background = 'transparent';
                            }}
                          >
                            <img
                              src="/iconos/edit.png"
                              style={{
                                height: 12,
                                width: 12,
                                filter: listSelected === element.id
                                  ? 'brightness(0) invert(1)'
                                  : 'none'
                              }}
                              alt="Editar"
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Aquí continúa el resto del código con <div className='cont-monitor'> ... */}
          <div className='cont-monitor'>
            {(internalError) ?
              <InternalError />
              :
              <PanelTableGroups
                key={listSelected}
                mode={mode}
                dataView={dataView}
                techSelected={techSelected}
                listSelected={listSelected}
                handleShowPopup={handleShowPopup}
                server={server}
                title='work station'
                languaje={languaje}
                hostSelected={hostSelected}
                setHostSelected={setHostSelected}
                openAddHostModal={openAddHostModal}
                showHistoric={showHistoric}
                dataAnalisis={dataAnalisis}
                municipios={municipios}
              />
            }


          </div>
        </div>

      </div>
      {/* <Modal
    isOpen={addHostModalOpen}
    // isOpen={true}
    // onAfterOpen={afterOpenExeption}
    onRequestClose={closeAddHostModal}
    style={addHostModalStyles}
    contentLabel="Example Modal2"
    // shouldCloseOnOverlayClick={false}
    >
      <ModalEvents dataView={dataView} deviceId={listSelected} server={server} handleShowPopup={handleShowPopup}  hostSelected={hostSelected}  languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalEvents> 
      
</Modal> */}

      <Modal
        isOpen={modalAddCorIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeModalAddCor}
        style={addHostModalStyles}
        contentLabel="Example Modal"
      >
        <ModalAddGroup editActive={editActive} tab={tab} search_tabs={search_tabs} poolObjectRows={poolObjectRows} setPoolObjectRows={setPoolObjectRows} poolRows={poolRows} server={server} handleShowPopup={handleShowPopup} setPoolRows={setPoolRows} languaje={languaje} mode={mode} closeAddHostModal={closeModalAddCor} />
      </Modal>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalDeleteTab handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={search_tabs} server={server} user={tab} closDeleteUserModal={closDeleteUserModal}></ModalDeleteTab>
      </Modal>
    </>
  );
};

export default PaneGrupos;
